import type { DexProvider } from '@ipfabric/utils';
import { ButtonAnchor } from 'components/Button/ButtonAnchor';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

interface Props {
  identityProviders: DexProvider[];
  /** Callback triggered when a link to a SSO url was clicked */
  onRedirectToSso?: () => void;
}

export const SingleSignOn: FC<Props> = (props) => {
  const {
    auth: { singleSignOn: singleSignOnMsg },
  } = useLocale();

  return (
    <div className='w-full'>
      {props.identityProviders.length === 0 ? (
        <div className='text-center text-xs'>
          {singleSignOnMsg.notConfigured}{' '}
          <a
            className='font-bold'
            href='https://docs.ipfabric.io/latest/IP_Fabric_Settings/administration/sso'
            target='_blank'
            rel='noreferrer'
          >
            {singleSignOnMsg.howToSetup}
          </a>
        </div>
      ) : (
        <div className='mx-4 flex flex-wrap justify-center'>
          {props.identityProviders.map(({ name, url }) => (
            <ButtonAnchor
              key={name}
              className='sso__button mx-2.5 mt-4'
              href={url}
              onClick={() => {
                props.onRedirectToSso?.();
              }}
              variant='secondary'
              accent='positive'
              type='button'
            >
              {singleSignOnMsg.continueWith(name)}
            </ButtonAnchor>
          ))}
        </div>
      )}
    </div>
  );
};
